<template>
  <header class="app-navbar">
    <div class="app-navbar__inner">
      <div class="app-navbar__left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            class="text-white mt-[3px] cursor-pointer"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink :to="{ name: 'home' }" class="brand-lockup inline-flex items-start" aria-label="Pacific Link™">
          <img src="/logo-word-t.png" class="h-12 object-contain cursor-pointer" alt="" />
          <sup class="brand-mark" aria-hidden="true">™</sup>
        </RouterLink>
      </div>

      <div class="app-navbar__right">
        <template v-if="!isMobile">
          <ProgramsDropdown class="app-navbar-actions__item" />
          <VaButton
            preset="secondary"
            color="textInverted"
            class="app-navbar-actions__item flex-shrink-0 mx-0"
            :to="{ name: 'news' }"
          >
            <div>{{ t('menu.news') }}</div>
          </VaButton>
          <VaButton
            preset="secondary"
            color="textInverted"
            class="app-navbar-actions__item flex-shrink-0 mx-0"
            :to="{ name: 'about-us' }"
          >
            <div>{{ t('menu.about') }}</div>
          </VaButton>
          <VaButton
            preset="secondary"
            color="textInverted"
            class="app-navbar-actions__item flex-shrink-0 mx-0"
            :to="{ name: 'partnership' }"
          >
            <div>{{ t('menu.partnership') }}</div>
          </VaButton>
          <VaButton
            preset="secondary"
            color="textInverted"
            class="app-navbar-actions__item flex-shrink-0 mx-0"
            :to="{ name: 'contact-us' }"
          >
            <div>{{ t('menu.contact') }}</div>
          </VaButton>
        </template>
        <LanguagesDropdown class="app-navbar-actions__item" />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import ProgramsDropdown from './components/dropdowns/ProgramsDropdown.vue'
import { useI18n } from 'vue-i18n'
import LanguagesDropdown from './components/dropdowns/LanguagesDropdown.vue'

const { t } = useI18n()
defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.app-navbar {
  z-index: 2;
  height: 5rem;
  background: #064e8a;
  display: flex;
  align-items: center;
}

.app-navbar__inner {
  width: 100%;
  padding: 0 10%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.app-navbar__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.brand-lockup {
  text-decoration: none;
}

.brand-mark {
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
  margin-left: -0.1rem;
  margin-top: 0.55rem;
}

.app-navbar__right {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
